import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';

const HelperDisplayName = ({ helperEmail }) => {
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHelperName = async () => {
      try {
        setLoading(true);
        
        // Check if helperEmail is valid
        if (!helperEmail || typeof helperEmail !== 'string') {
          setDisplayName('ไม่ระบุ');
          return;
        }
        
        // If it's already a display name (not an email), use it directly
        if (!helperEmail.includes('@')) {
          setDisplayName(helperEmail);
          return;
        }
        
        // Try to find user by email in users collection
        // We need to query all users and find by email since Firestore doesn't support email queries directly
        const usersRef = collection(db, 'users');
        const usersSnapshot = await getDocs(usersRef);
        
        let foundUser = null;
        usersSnapshot.forEach(doc => {
          const userData = doc.data();
          if (userData.email === helperEmail) {
            foundUser = userData;
          }
        });

        if (foundUser) {
          // Use displayName if available, otherwise use email
          const name = foundUser.displayName || foundUser.name || helperEmail.split('@')[0];
          setDisplayName(name);
        } else {
          // Fallback to email username part
          setDisplayName(helperEmail.split('@')[0]);
        }
      } catch (error) {
        console.error('Error fetching helper name:', error);
        // Safe fallback
        if (helperEmail && typeof helperEmail === 'string') {
          if (helperEmail.includes('@')) {
            setDisplayName(helperEmail.split('@')[0]);
          } else {
            setDisplayName(helperEmail);
          }
        } else {
          setDisplayName('ไม่ระบุ');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchHelperName();
  }, [helperEmail]);

  if (loading) {
    return <span className="text-xs text-purple-700">กำลังโหลด...</span>;
  }

  return <span className="text-xs text-purple-700">{displayName}</span>;
};

export default HelperDisplayName;
